import { React, useState, useEffect } from 'react'
import ReportList from "../components/Reports.json";
import Report from '../components/Report'
import img from '../assets/Banners/Banner - 002_shorter.jpg'

export default function MonthlyReport() {

    const [totallistList, settotalListList] = useState([]);

    useEffect(() => {

        ReportList.sort((a, b) => {
            return (b.id) - (a.id);
        });

        var totallist = [];

        ReportList.forEach(e => {
            totallist.push(<Report event={e} key={e.id} />)
        });

        settotalListList(totallist);


    }, [])


    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div style={{ position: "relative", width: "100%" }}>
                    <img
                        src={img}
                        className="d-block w-100"
                        style={{ objectFit: "cover" }}
                    />
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        right: "0",
                        transform: "translateY(-50%)",
                        textAlign: "center",
                    }}>
                        <div className="container">
                            <h1 style={{ fontWeight: '600', fontSize: 'clamp(0.8rem, 3vw, 2.5rem)' }} id="bannerText">
                                Reports
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="container py-4">
                    <h1 className='mb-3'>Commissioners Court Reports</h1>

                    <table className="table table-striped table-hover mx-auto">
                        <tbody>
                            {(totallistList.length === 0) ? <h3 className="text-center py-2" style={{ color: "grey" }}><em>No Reports Available</em></h3> : totallistList}
                        </tbody>
                    </table>


                </div>
            </main>
        </div>
    )
}